/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class PasswordRequiredValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Is required"
	}

	logic(x) {
		if (x == null) {
			return true;
		}

		return x != null && x.current != "" && x.password != "";
	}

	message() {
		return "Required";
	}
}